import { LucideIcon } from "lucide-react";

interface CategoryCardProps {
  icon: LucideIcon;
  title: string;
  href: string;
  count?: number;
}

export function CategoryCard({ icon: Icon, title, href, count }: CategoryCardProps) {
  return (
    <a
      href={href}
      className="bg-card rounded-lg shadow-sm p-4 text-center hover:shadow-md transition-shadow cursor-pointer group"
    >
      <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary/10 flex items-center justify-center text-secondary group-hover:bg-primary/15 transition-colors">
        <Icon className="w-6 h-6" />
      </div>
      <h3 className="font-medium text-sm text-card-foreground">{title}</h3>
      {count !== undefined && (
        <p className="text-xs text-muted-foreground mt-1">
          {count} {count === 1 ? 'produto' : 'produtos'}
        </p>
      )}
    </a>
  );
}